module.exports = {
    //use to be form-horizontal
    formClass: ''
}


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/FormTemplate-style.js
 **/